"use client";
import ProducrCard from "@/components/Product/product-card";
import { defaultLocale } from "@/config.ts";
import { getChannelLanguageMap } from "@/lib/api/channel";
import { getCollectionProducts } from "@/lib/api/product";
import { RightOutlined } from "@ant-design/icons";
import { Skeleton } from "antd";
import { useTranslations } from "next-intl";
import { Link, useRouter } from "@/navigation";
import { useEffect, useRef, useState } from "react";

// import InquiryButton from "@/components/Inquiry/Button";
// import { useUserAuth } from "@/lib/hooks/useUserAuth";
// import { App } from "antd";

export default function ShopByCate({ locale }: { locale: string }) {
	const [isVisible, setIsVisible] = useState(false);
	const [isVisible2, setIsVisible2] = useState(false);
	const [channel, setChannel] = useState<any>();
	const [colList1, setColList1] = useState<any>();
	const [colList2, setColList2] = useState<any>();

	const ref = useRef<HTMLDivElement>(null);
	const ref2 = useRef<HTMLDivElement>(null);
	const t = useTranslations("");
	const dataList = [
		{
			key: "1",
			title: "SOLAR ENERGY STORAGE PANEL",
			slug: "/",
			img: "/image/home/p1.jpg",
		},
		{
			key: "2",
			title: "ENERGY STORAGE BATTERY",
			slug: "/",
			img: "/image/home/p1.jpg",
		},
		{
			key: "3",
			title: "CAR SOLAR PANEL",
			slug: "/",
			img: "/image/home/p1.jpg",
		},
		{
			key: "4",
			title: "CAR SOLAR PANEL",
			slug: "/",
			img: "/image/home/p1.jpg",
		},
	];

	useEffect(() => {
		const observer = new IntersectionObserver(
			(entries) => {
				const entry = entries[0];
				if (entry.isIntersecting) {
					setIsVisible(true);
					observer.disconnect(); // 动画触发后停止观察
				}
			},
			{
				root: null, // 使用浏览器视窗为根
				threshold: 0.07, // 当元素 10% 可见时触发
				rootMargin: "0px 0px -100px 0px", // 在元素离开视口100px前触发
			},
		);

		if (ref.current) {
			observer.observe(ref.current);
		}

		return () => {
			if (ref.current) {
				observer.unobserve(ref.current);
			}
		};
	}, []);
	useEffect(() => {
		const observer = new IntersectionObserver(
			(entries) => {
				const entry = entries[0];
				if (entry.isIntersecting) {
					setIsVisible2(true);
					observer.disconnect(); // 动画触发后停止观察
				}
			},
			{
				root: null, // 使用浏览器视窗为根
				threshold: 0.07, // 当元素 10% 可见时触发
				rootMargin: "0px 0px -100px 0px", // 在元素离开视口100px前触发
			},
		);

		if (ref2.current) {
			observer.observe(ref2.current);
		}

		return () => {
			if (ref2.current) {
				observer.unobserve(ref2.current);
			}
		};
	}, []);
	useEffect(() => {
		getChannelLanguageMap().then((res) => {
			if (res[defaultLocale]) {
				setChannel(res[defaultLocale]);
			}
		});
	}, []);
	useEffect(() => {
		if (channel) {
			getCollectionProducts({ slug: "home-series", locale, channel }).then((res) => {
				if (res) {
					setColList1(res.collection.products?.edges);
				}
			});
			getCollectionProducts({ slug: "home-solarPanels", locale, channel }).then((res) => {
				if (res) {
					setColList2(res.collection.products?.edges);
				}
			});
		}
	}, [channel]);
	// useEffect(() => {
	// 	console.log("this is colList1", colList1);
	// 	console.log("this is colList2", colList2);
	// }, [colList1, channel]);

	// async function AddCart() {
	// 	if (!isLogin()) return message.error("NOT Login");
	// 	if (!props.VariantActive) return;
	// 	// @ts-ignore
	// 	await addToCart({
	// 		channel: "default-channel",
	// 		selectedVariantID: props.VariantActive.id,
	// 		quantity: count,
	// 	});
	// 	return setLoading(false);
	// }

	return (
		<div>
			{/* 第一部分精选商品 */}
			<div className="container mt-[50px] flex flex-col max-md:mt-[50px]">
				<div className="flex justify-between max-lg:justify-center max-sm:flex-col max-sm:items-center">
					<div></div>
					<div className="flex flex-col items-center gap-2">
						<h2 className="group relative mb-4 text-center font-queens text-[32px] font-medium md:text-[42px] lg:text-[52px]">
							{t("home.shopb")}
							<span className="absolute bottom-0 left-0 h-0.5 w-0 bg-black transition-all duration-300 group-hover:w-full"></span>
						</h2>
					</div>

					<Link className="mt-[50px] flex max-lg:hidden" href={"/products"}>
						<p className=" pr-2 text-center text-[#989898] max-md:flex-nowrap">{t("home.hs3")}</p>
						<div className="flex h-[20px] w-[20px] items-center justify-center rounded-2xl bg-[#E9E9E9]">
							<p className="font-bold text-black">{">"}</p>
						</div>
					</Link>
				</div>
				<div
					className="grid grid-cols-4 gap-[65px] max-xl:grid-cols-2 max-lg:grid-cols-2 max-md:grid-cols-1 max-sm:grid-cols-2 max-sm:gap-[15px]"
					ref={ref}
				>
					{colList1?.length > 0
						? colList1.slice(0, 4).map((item: any, index: number) => {
								return (
									<div
										key={item.node.slug}
										className={` animate__animated  ${
											isVisible ? "animate__fadeInUp animate__fadeInLeft " : "opacity-0"
										}  animate `}
										style={{ animationDelay: `${index * 0.2}s` }}
									>
										<ProducrCard productItem={item.node as any} haveButton="false" locale={locale} />
									</div>
								);
							})
						: Array.from({ length: 4 }, (_, index) => index).map((item) => {
								return (
									<div key={item} className="flex flex-col space-y-4">
										<Skeleton.Image active style={{ width: "100%", height: 350 }} />
										<div className="space-y-2">
											<Skeleton active paragraph={false} title={{ width: "70%" }} />
											<Skeleton active paragraph={false} title={{ width: "40%" }} />
										</div>
									</div>
								);
							})}
				</div>
				<div
					className="grid grid-cols-4 gap-[65px] max-xl:grid-cols-2 max-lg:grid-cols-2 max-md:hidden max-md:grid-cols-1 max-sm:grid-cols-2 max-sm:gap-[15px]"
					ref={ref2}
				>
					{colList2?.length > 0
						? colList2.slice(0, 4).map((item: any, index: number) => {
								return (
									<div
										key={item.node.slug}
										className={` animate__animated  ${
											isVisible2 ? "animate__fadeInUp animate__fadeInLeft " : "opacity-0"
										}  animate `}
										style={{ animationDelay: `${index * 0.2}s` }}
									>
										<ProducrCard
											key={item.node.slug}
											productItem={item.node as any}
											haveButton="false"
											locale={locale}
										/>
									</div>
								);
							})
						: Array.from({ length: 4 }, (_, index) => index).map((item) => {
								return (
									<div key={item} className="flex flex-col space-y-4">
										<Skeleton.Image active style={{ width: "100%", height: 350 }} />
										<div className="space-y-2">
											<Skeleton active paragraph={false} title={{ width: "70%" }} />
											<Skeleton active paragraph={false} title={{ width: "40%" }} />
										</div>
									</div>
								);
							})}
				</div>
			</div>

			{/* 第二部分精选商品 */}
			{/* <div className="container mt-[125px] flex flex-col font-queens ">
				<div className="flex justify-between max-sm:flex-col max-sm:items-center">
					<h2 className="mb-[50px] text-[46px] font-bold leading-[40px] max-md:text-[24px] max-sm:text-center max-sm:text-[32px]">
						{t("home.hs5")}
					</h2>
					<Link className="mt-[50px] flex max-sm:hidden" href={"/products"}>
						<p className=" pr-2 text-[#989898]">{t("home.hs3")}</p>
						<div className="flex h-[20px] w-[20px] items-center justify-center rounded-2xl bg-[#E9E9E9]">
							<RightOutlined style={{ fontSize: "10px", color: "black", fontWeight: "bold" }} />
						</div>
					</Link>
				</div>
				<div
					className="grid grid-cols-4 gap-[65px] max-xl:grid-cols-2 max-lg:grid-cols-2 max-md:grid-cols-1 max-sm:grid-cols-2 max-sm:gap-[15px]"
					ref={ref2}
				>
					{colList2?.length > 0
						? colList2.slice(0, 4).map((item: any, index: number) => {
								return (
									<div
										key={item.node.slug}
										className={` animate__animated  ${
											isVisible2 ? "animate__fadeInUp animate__fadeInLeft " : "opacity-0"
										}  animate `}
										style={{ animationDelay: `${index * 0.2}s` }}
									>
										<ProducrCard
											key={item.node.slug}
											productItem={item.node as any}
											haveButton="false"
											locale={locale}
										/>
									</div>
								);
							})
						: Array.from({ length: 4 }, (_, index) => index).map((item) => {
								return (
									<div key={item} className="flex flex-col space-y-4">
										<Skeleton.Image active style={{ width: "100%", height: 350 }} />
										<div className="space-y-2">
											<Skeleton active paragraph={false} title={{ width: "70%" }} />
											<Skeleton active paragraph={false} title={{ width: "40%" }} />
										</div>
									</div>
								);
							})}
				</div>
			</div> */}
			{/* 横幅banner */}
			{/* <div className="mt-[90px]">
				<img
					src="/image/home/hengfu.webp"
					alt="home-product-pic"
					className="h-[650px] w-full object-cover max-md:h-full "
				/>
			</div> */}
		</div>
	);
}
